import { Component, NgZone, OnInit } from '@angular/core';
import { CentrifugeService, ChannelStatus } from 'src/app/services/centrifuge/centrifuge.service';
import { MatDialog } from '@angular/material';
import storage from 'store';
import { map } from 'rxjs/operators';
import _get from 'lodash/get';
import { NotificationModel } from './interfaces/calendar-model.interface';
import { CalendarSchedulesModalComponent } from './calendar-schedules-modal/calendar-schedules-modal.component';
import { UserInfoService } from 'src/app/services/user-info/user-info.service';

@Component({
  selector: 'app-calendar-schedules',
  templateUrl: './calendar-schedules.component.html',
  styleUrls: ['./calendar-schedules.component.scss']
})
export class CalendarSchedulesComponent implements OnInit {

  public user = storage.get('user');

  public channelName: string = `user_notifications_${this.user.crm_id}`;

  public subscribes: any = {};

  public notifications: NotificationModel[] = [];

  constructor(
    private centrifugeService: CentrifugeService,
    private userInfoService: UserInfoService,
    private ngZone: NgZone,
    private matDialog: MatDialog,
  ) { }

  ngOnInit() {
    this.subscribeNotifications();
  }

  private subscribeNotifications(): void {
    if(storage.get('calendar_schedules_triggered')) {
      return;
    }

    this.subscribes[this.channelName] = this.centrifugeService.listen(this.channelName, (status) => {
      if(status === ChannelStatus.SUBSCRIBE) {
        this.triggerCalendarNotifications();
      }
    }).pipe(
      map(res => _get(res, 'data', [])),
    ).subscribe((data) => {
      if (data) {
        this.ngZone.run(() => {
          this.notifications = data || [];

          if(this.notifications.length > 0) {
            this.openNotificationsModal();
            this.subscribes[this.channelName].unsubscribe();
          }
        });
      }
    });
  }

  private triggerCalendarNotifications(): void {
    if(storage.get('calendar_schedules_triggered')) {
      return;
    }

    this.userInfoService.triggerCalendarNotifications({
      user: {
        id: this.user.id,
        crm_id: this.user.crm_id,
        role: this.user.role,
      }
    }).subscribe(
      (res) => {
        storage.set('calendar_schedules_triggered', true);
      },
      (error) => {
        storage.set('calendar_schedules_triggered', true);
      }
    );
  }

  private openNotificationsModal(): void {
    this.matDialog.open(CalendarSchedulesModalComponent, {
      width: '600px',
      maxWidth: '90vw',
      data: {
        notifications: this.notifications
      }
    })
  }
}

